import React from "react";
import {useTheme} from "@emotion/react";

import {mb, mt} from "@pg-design/helpers-css";
import {BrandRPLogoIcon} from "@pg-design/icons-module";
import {useUserDevice} from "@pg-mono/user-device";

export const AuthorBoxImgPlaceholder = () => {
    const theme = useTheme();
    const {isMobile} = useUserDevice();

    return (
        <BrandRPLogoIcon
            wrapperColor={theme.colors.primary}
            wrapperType="circle"
            size={isMobile ? "16" : "12"}
            wrapperSize={isMobile ? "21" : "17"}
            css={isMobile ? [mb(8), mt(8)] : null}
        />
    );
};
